import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Loader2, ArrowRight, Flame } from 'lucide-react';
import { base44 } from '@/api/base44Client';
import RigCard from '@/components/showcase/RigCard';

export default function FeaturedShowcaseRigs() {
  const { data: rigs = [], isLoading } = useQuery({
    queryKey: ['featured-showcase-rigs'],
    queryFn: () => base44.entities.ShowcaseRig.filter({ featured: true }, 'sort_order', 20),
  });

  if (isLoading) {
    return (
      <section className="py-20 px-6 lg:px-10">
        <div className="max-w-7xl mx-auto flex justify-center">
          <Loader2 className="w-6 h-6 animate-spin text-primary" />
        </div>
      </section>
    );
  }

  if (rigs.length === 0) return null;

  return (
    <section className="py-24 px-6 lg:px-10 border-t border-white/5 bg-[#0d0d0f]">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12 gap-4 flex-wrap">
          <div>
            <p className="text-primary text-xs font-bold tracking-widest mb-3 flex items-center gap-2">
              <Flame className="w-3.5 h-3.5" /> OUR SIMULATORS
            </p>
            <h2 className="text-white font-black text-3xl md:text-5xl uppercase leading-tight">
              Step Into The Rig
            </h2>
            <p className="text-white/40 mt-4 max-w-lg text-sm">
              Explore our fleet of professional-grade simulators. Each one engineered for a different kind of racing — find the one built for you.
            </p>
          </div>
          <Link
            to="/simulators"
            className="inline-flex items-center gap-2 bg-primary/20 border border-primary/40 text-white hover:bg-primary hover:border-primary font-bold text-xs tracking-widest px-5 py-3 transition-colors"
          >
            VIEW ALL RIGS <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {rigs.map((rig, i) => (
            <motion.div
              key={rig.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
            >
              <RigCard rig={rig} index={i} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}